<template>
  <nna-container :spacing=10 bottom-bar-active>
    <md-datepicker v-model="when" @md-closed="onSelectedDate($event)">
      <label>Quando?</label>
    </md-datepicker>
    <services-list />    
    <nna-action-footer v-if="inCart">
      <div class="cart__total md-layout md-gutter">
        <div class="md-layout-item text-align-left">
          <div class="cart__totalLabel">Totale</div>
        </div>
        <div class="md-layout-item text-align-right">
          <div class="cart__totalSum">{{servicesTotal}}€</div>
        </div>
      </div>
      <nna-button @click.native="$router.push({ name: 'services.order.summary' })">PROCEDI CON IL PAGAMENTO</nna-button>
    </nna-action-footer>    
  </nna-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import servicesList from '@/modules/common/components/services/servicesList'
export default {
  name: 'Services',
  components: {
    servicesList,    
  },
  data() {
    return {
      when: '',       
    }
  },
  watch: {
    when(val) {
      this.onSearch(val)
    }
  },
  computed: {
    ...mapGetters({
      shop: 'shops/current',
      servicesTotal: 'cart/servicesTotal',
      reservationDate: 'global/reservationDate',
      reservationDateForServer: 'global/reservationDateForServer',
      cart: 'cart/cart',
    }),
    inCart() {
      return this.cart.length > 0
    },
  },
  methods: {
    ...mapActions({     
      getServices: 'shops/getServices', 
    }),
    onSelectedDate(date) {
      this.onSearch()
    },  
    onSearch(date) {
      let when = date
      if(when) {
        this.$store.commit("cart/CART_CLEAN")
        this.$store.commit("global/SET_RESERVATION_DATE", when)
        this.getServices()
      }
    }    
  },
  mounted() {
    let date = this.reservationDate
    if(date) {
      this.when = date
    }    
  },
  beforeDestroy() {},
}
</script>

<style lang="scss" scoped>
.cart__total {
  background: #fff;
  padding: 10px;
  border-top: 1px solid #ddd;
}
.container {
  padding-bottom: 100px;
}
</style>



// WEBPACK FOOTER //
// src/modules/Shop/pages/Services.vue